
import api from '@/utils/api'
import heada_Image from '@/assets/image/profile_picture.png'
import Router from "@/router";
import { MessageBox, Message } from "element-ui";
const defaultUser = {
  auth: false,
  canTakeEvidence: false,
  company: null,
  creator: false,
  deletedAt: null,
  idNumber: null,
  inviteCode: '',
  name: null,
  phone: '',
  token: '',
  uuid: '',
  nickname: '',
  serviceUntil: 0,
  refereeCount: 0,
  reward: 0,
  newerBundleCount: 0,
  monthBundleCount: 0,
  hasPassword: false,
  avatar: '',
  voucherCount: 0,
  balance: 0,
  newVersion:null,
  showCheckIn:false
}

const state = {
  user: { ...defaultUser },
  balance: 0,
  beans: 0,
  showUserAuth:false
}

const getters = {
  profilePicture: () => heada_Image,
  // 公司认证状态
  companyAuth(state) {
    return !!state.user.company
  },
  //个人认证状态
  auth(state) {
    return state.user.auth
  },
  authType(state, getters) {
    if (!getters.auth) {
      return 'unAuth';
    }
    if (!getters.companyAuth) {
      return 'unCompanyAuth';
    }
    return 'allAuth'
  },
  token: state => state.user.token,
}

const mutations = {
  setUserInfo(state, payload) {
    let next = { ...state.user, ...payload };
    if (payload.token === null || payload.token === undefined) {
      next.token = state.user.token;
    }
    state.user = next;
  },
  setData(state, { key, value }) {
    state[key] = value
  },
  logout(state) {
    state.user = { ...defaultUser }
  },
  setToken(state, payload) {
    state.user.token = payload
  },
  setShowUserAuth(state, payload){
    state.showUserAuth = payload
  }
}

const actions = {
  async getAccount({ dispatch }) {
    const { status, data } = await api.getAccount()
    if (status === 200) {
      dispatch('setUserInfo', data)
    }
    return
  },

  async changeToken({ dispatch, commit }, token) {
    commit('setToken', token)
    await dispatch('getAccount');
    Router.push({
      name: "home"
    });
    // setTimeout(() => {
    //   window.location.reload();
    // }, 500);
  },


  setUserInfo({ commit, state, dispatch, rootState }, params) {
    let data = params;
    if (data.avatar) {
      data.avatar = rootState.app.oss + data.avatar
    }
    if (!data.name) {
      data.name = data.phone
    }
    commit('setUserInfo', data)
    dispatch('userLog/saveUserLog', data, { root: true })
    dispatch('customerService/configureUser', data, { root: true });
  },

  logout({ commit, dispatch }) {
    commit('logout')
    dispatch('userLog/clearUserLog', {}, { root: true })
    localStorage.removeItem('vuex');
  },
  async buy({ state }, price) {
    const { user: { balance } } = state;
    console.log(balance)

    if (price <= balance) {
      return balance; // ✅ 余额足够，直接返回
    }

    try {
      await MessageBox.confirm("余额不足，请充值后再进行购买。", "提示", {
        confirmButtonText: "前去充值",
        cancelButtonText: "取消",
        type: "warning",
      });
      // 用户点击了 “前去充值”
      Router.push({
        name: "recharge",
        params: {
          type: "chongzhi",
        },
      });
      throw new Error("余额不足，已提示充值"); // ❌ 强制中断购买流程
    } catch (err) {
      // 用户点击了 “取消” 或其他错误
      throw new Error("余额不足，用户取消充值");
    }
  },
  toAccountCompanyAuth({ state, dispatch }) {
    const { name } = state.user;
    if (name) {
      dispatch("qiyeshiming/showMode1", true, { root: true })
    } else {
      MessageBox.confirm("企业实名前先进行个人实名, 是否继续?", "提示", {
        confirmButtonText: "去个人实名",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        dispatch("toAccountAuth");
      });
    }
  },
  toAccountAuth({ dispatch }){
    // Router.push({
    //   name: "UserAuth"
    // });
    dispatch('onShowUserAuth')
    dispatch("app/setUserDrawerShow", false, { root: true })
  },
  onShowUserAuth({ commit }){
    commit('setShowUserAuth', true)
  },
  onHideUserAuth({ commit }){
    commit('setShowUserAuth', false)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}